module.exports = __webpack_public_path__ + "img/SC.81769c76.svg";